// API Base URL configuration
// - Local dev: Vite proxy handles /api/* -> localhost:8001
// - Production: Cloudflare Worker handles /api/* -> Railway backend
// Using relative URL so both environments work seamlessly

export const API_BASE_URL = '/api/v1'
